// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1WMrK","emails":"CreateEditClinics_emails__3FiuO","emailTagLabel":"CreateEditClinics_emailTagLabel__1rrSi"};